import NotificationProductCard from './NotificationProductCard';
export default NotificationProductCard;
